import { Injectable, Injector } from '@angular/core';
import { AuthService } from './services/auth.service';
import { BrandService } from './services/brand.service';
import { InstallService } from './services/install.service';
import { LanguageService } from './services/language.service';
import { NetworkService } from './services/network.service';
import { PlanService } from './services/plan.service';
import { Context } from './context';

export function initializeApp(appInit: AppInit) {
  return (): Promise<any> => {
    return appInit.init();
  }
}

@Injectable({
  providedIn: 'root'
})
export class AppInit {

  constructor(
    private injector: Injector
  ) { }

  public async init() {
    this.injector.get(InstallService).init();

    const authService = this.injector.get(AuthService);

    await this.injector.get(NetworkService).init();

    await this.injector.get(BrandService).init();
    await this.injector.get(LanguageService).init();
    await authService.init();

    if (Context.user) {
      await this.injector.get(PlanService).init();
    }
  }
}
